import userAgents from '../../../config/userAgent.json';

export interface UserAgentOption {
  name: string;
  value: string;
  label: string;
  values?: string;
}

export const userAgentsCreator = (): UserAgentOption[] => {
  const userAgentNames = Object.keys(userAgents);
  const userAgentValues = Object.values(userAgents) as string[];
  const arr: UserAgentOption[] = [{ name: '', value: '', label: 'سفارشی' }];

  for (let i = 0; i < userAgentNames.length; i++) {
    const name = userAgentNames[i];
    arr.push({
      name,
      label: name.replace(/_/g, ' '),
      value: userAgentValues[i]
    });
  }

  return arr;
};
